import React from 'react'
import classNames from 'classnames'
import type { Props } from './types'
import styles from './style.module.scss'

const Flag: React.FC<Props> = ({
  children,
  text,
  placement,
  type,
  main,
  category,
  highlighted,
  clickHandler,
  extraClasses,
}) => {
  const classes = classNames(styles['flag'], [
    [styles[`type--${type}`]],
    extraClasses,
  ])

  function onClick() {
    if (clickHandler) clickHandler()
  }

  return (
    <label
      className={classes}
      style={{
        bottom: `${100 - placement?.Position.Y}%`,
        left: `${placement?.Position.X}%`,
        height: `${placement?.Position.Length}%`,
        color: main
          ? undefined
          : highlighted
          ? category?.attributes.Color
          : 'white',
      }}
    >
      <div className={styles['flag-post']}>
        <div className={styles['flag-label']}>
          <span
            className={classNames(
              [
                styles[
                  `align--h-${placement?.LabelPlacement.HorizontalAlignment}`
                ],
              ],
              [
                styles[
                  `align--v-${placement?.LabelPlacement.VerticalAlignment}`
                ],
              ]
            )}
            style={{
              top: `${(placement?.LabelPlacement.VerticalOffset || 0) / 10}rem`,
              left: `${(placement?.LabelPlacement.HorizontalOffset || 0) / 10}rem`,
            }}
            onClick={() => onClick()}
          >
            {text}
          </span>
        </div>
      </div>
      {children}
    </label>
  )
}

export default Flag
